export default __webpack_public_path__ + "static/soehne-web-extrafett-kursiv-082cb71db59472b2b1eb18acec441ae9.woff";